@let data = section();

<section class="cms-content-group tg-section">
    <div class="tg-container">
        @if (data.contentGroupContent) {
            <div class="cms-content-group__intro">
                <div class="cms-content" [innerHTML]="data.contentGroupContent | trustHtml"></div>
            </div>
        }

        <div class="cms-content-group__grid">
            @for (item of data.itemsList; track item.id) {
                <div
                    class="cms-content-group__cell"
                    [class.cms-content-group__cell--expanded]="isExpanded(item.id)"
                >
                    <app-module-chip
                        [label]="item.itemLabel"
                        [expandable]="true"
                        [expanded]="isExpanded(item.id)"
                        [image]="item.itemLabelImage"
                        (toggled)="toggle(item.id)"
                    />

                    @if (item.itemContent) {
                        <div
                            class="cms-content-group__panel"
                            [attr.inert]="isExpanded(item.id) ? null : ''"
                        >
                            <div
                                class="cms-content"
                                [innerHTML]="item.itemContent | trustHtml"
                            ></div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</section>
